import { render, staticRenderFns } from "./UnitGrid.vue?vue&type=template&id=4b79a934"
import script from "./UnitGrid.vue?vue&type=script&lang=js"
export * from "./UnitGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports